import { render, staticRenderFns } from "./SimpleProduct.vue?vue&type=template&id=8dbd4b0e"
import script from "./SimpleProduct.vue?vue&type=script&lang=js"
export * from "./SimpleProduct.vue?vue&type=script&lang=js"
import style0 from "./SimpleProduct.vue?vue&type=style&index=0&id=8dbd4b0e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports